import React from "react";
import AddIcon from "@material-ui/icons/Add";
import { CircularProgress, Box, makeStyles, Button } from "@material-ui/core";

const useStyles = makeStyles({
    imgContainer: {
        width: "3rem",
        height: "3rem",
        marginRight: "1.5rem",
    },
    container: {
        display: "flex",
        alignItems: "center",
    },
});

export const imageRenderer = (
    value,
    name,
    updateImage,
    imageIsLoading,
    mutable,
    acceptExtensions = ".svg",
    hotelId
) => {
    const classes = useStyles();

    const changeImgHandler = (e) => {
        updateImage(name, e.target.files[0]);
    };

    let fieldProps = {
        type: "file",
        hidden: true,
        accept: acceptExtensions,
    };

    let urlValue;

    if (value instanceof File) {
        urlValue = URL.createObjectURL(value);
    } else if (value?.base64str) {
        urlValue = value?.base64str;
    } else {
        urlValue = `/hotel_images/${hotelId}/${value}`
    }

    return imageIsLoading ? (
        <CircularProgress size={30} />
    ) : (
        <Box className={classes.container} mr={1}>
            {value ? (
                <Box className={classes.imgContainer} mr={1}>
                    <img
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                        src={urlValue}
                        alt="Image Error"
                    />
                </Box>
            ) : (
                <div>Нет изображения </div>
            )}

            {mutable && (
                <React.Fragment>
                    <input
                        id="category-img"
                        {...fieldProps}
                        onChange={changeImgHandler}
                    />
                    <label htmlFor="category-img">
                        <Button
                            startIcon={<AddIcon />}
                            component="span"
                            variant="contained"
                        >
                            Загрузить изображение
                        </Button>
                    </label>
                </React.Fragment>
            )}
        </Box>
    );
};
